import { AuthAction, AuthActionTypes } from '../actions/auth.actions';

export interface AuthState {
  email: string | undefined;
  isLoggedIn: boolean;
  __isAdmin: boolean; // original real value
  isAdmin: boolean; // for display purposes
}

const INITIAL_STATE: AuthState = {
  email: undefined,
  isLoggedIn: false,
  __isAdmin: false,
  isAdmin: false
};

export function authReducer(state: AuthState = INITIAL_STATE, action: AuthAction): AuthState {
  switch (action.type) {
    case AuthActionTypes.LOG_IN:
      return {
        ...state,
        email: action.payload.email,
        isLoggedIn: true,
        __isAdmin: action.payload.isAdmin,
        isAdmin: action.payload.isAdmin
      };

    case AuthActionTypes.LOG_OUT:
      return {
        ...state,
        email: undefined,
        isLoggedIn: false,
        __isAdmin: false,
        isAdmin: false
      };

    case AuthActionTypes.TOGGLE_ADMIN:
      // just an extra measure of security
      if (state.__isAdmin) {
        return {
          ...state,
          isAdmin: action.payload.displayAdmin
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
